// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Common Component Styles
 * Shared styles for reusable components
 */

/* Error Boundary */
.error-boundary {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-gray-50);
  padding: 1rem;
}

.dark .error-boundary {
  background-color: var(--color-slate-900);
}

.error-boundary__container {
  max-width: 28rem;
  width: 100%;
  background-color: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 2rem;
}

.dark .error-boundary__container {
  background-color: var(--color-slate-800);
}

.error-boundary__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  background-color: var(--color-danger-100);
  border-radius: 50%;
}

.dark .error-boundary__icon-wrapper {
  background-color: rgba(220, 38, 38, 0.2);
}

.error-boundary__icon {
  width: 2rem;
  height: 2rem;
  color: var(--color-danger-600);
}

.dark .error-boundary__icon {
  color: var(--color-danger-400);
}

.error-boundary__title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  text-align: center;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.error-boundary__message {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
}

.error-boundary__details {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: var(--color-gray-100);
  border-radius: var(--radius-lg);
}

.dark .error-boundary__details {
  background-color: var(--color-slate-700);
}

.error-boundary__details-summary {
  cursor: pointer;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  margin-bottom: 0.5rem;
}

.dark .error-boundary__details-summary {
  color: var(--color-gray-300);
}

.error-boundary__details-content {
  font-size: var(--font-size-xs);
  color: var(--color-danger-600);
  overflow: auto;
  white-space: pre-wrap;
}

.dark .error-boundary__details-content {
  color: var(--color-danger-400);
}

.error-boundary__actions {
  display: flex;
  gap: 0.75rem;
}

.error-boundary__actions .btn-primary,
.error-boundary__actions .btn-secondary {
  flex: 1 1;
}

/* Loading Skeletons */
.skeleton {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background-color: var(--color-gray-200);
  border-radius: var(--radius-md);
}

.dark .skeleton {
  background-color: var(--color-slate-700);
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.card-skeleton {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.card-skeleton__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.card-skeleton__body {
  margin-bottom: 1rem;
}

.table-skeleton {
  overflow: hidden;
}

.table-skeleton__table {
  width: 100%;
}

.table-skeleton__th {
  padding: 0.75rem 1.5rem;
}

.table-skeleton__td {
  padding: 1rem 1.5rem;
}

.chart-skeleton__title {
  height: 2rem;
  width: 12rem;
  margin-bottom: 1.5rem;
}

.chart-skeleton__chart {
  height: 16rem;
  width: 100%;
  margin-bottom: 1rem;
}

.chart-skeleton__legend {
  display: flex;
  gap: 1rem;
}

.chart-skeleton__legend-item {
  height: 1rem;
  flex: 1 1;
}

.grid-skeleton {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .grid-skeleton {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid-skeleton {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Search Bar */
.search-bar {
  position: relative;
}

.search-bar__icon-left {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  padding-left: 0.75rem;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.search-bar__icon-left svg {
  height: 1.25rem;
  width: 1.25rem;
  color: var(--color-gray-400);
}

.search-bar__input {
  padding-left: 2.5rem;
}

.search-bar__clear {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding-right: 0.75rem;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: var(--color-gray-400);
  cursor: pointer;
  transition: var(--transition-fast);
}

.search-bar__clear:hover {
  color: var(--color-gray-600);
}

.dark .search-bar__clear:hover {
  color: var(--color-gray-300);
}

.search-bar__clear svg {
  height: 1.25rem;
  width: 1.25rem;
}

`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,yDAAyD;EACzD,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/**\n * Common Component Styles\n * Shared styles for reusable components\n */\n\n/* Error Boundary */\n.error-boundary {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-gray-50);\n  padding: 1rem;\n}\n\n.dark .error-boundary {\n  background-color: var(--color-slate-900);\n}\n\n.error-boundary__container {\n  max-width: 28rem;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 2rem;\n}\n\n.dark .error-boundary__container {\n  background-color: var(--color-slate-800);\n}\n\n.error-boundary__icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4rem;\n  height: 4rem;\n  margin: 0 auto 1rem;\n  background-color: var(--color-danger-100);\n  border-radius: 50%;\n}\n\n.dark .error-boundary__icon-wrapper {\n  background-color: rgba(220, 38, 38, 0.2);\n}\n\n.error-boundary__icon {\n  width: 2rem;\n  height: 2rem;\n  color: var(--color-danger-600);\n}\n\n.dark .error-boundary__icon {\n  color: var(--color-danger-400);\n}\n\n.error-boundary__title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  text-align: center;\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.error-boundary__message {\n  text-align: center;\n  color: var(--color-text-secondary);\n  margin-bottom: 1.5rem;\n}\n\n.error-boundary__details {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: var(--color-gray-100);\n  border-radius: var(--radius-lg);\n}\n\n.dark .error-boundary__details {\n  background-color: var(--color-slate-700);\n}\n\n.error-boundary__details-summary {\n  cursor: pointer;\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n  margin-bottom: 0.5rem;\n}\n\n.dark .error-boundary__details-summary {\n  color: var(--color-gray-300);\n}\n\n.error-boundary__details-content {\n  font-size: var(--font-size-xs);\n  color: var(--color-danger-600);\n  overflow: auto;\n  white-space: pre-wrap;\n}\n\n.dark .error-boundary__details-content {\n  color: var(--color-danger-400);\n}\n\n.error-boundary__actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.error-boundary__actions .btn-primary,\n.error-boundary__actions .btn-secondary {\n  flex: 1;\n}\n\n/* Loading Skeletons */\n.skeleton {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  background-color: var(--color-gray-200);\n  border-radius: var(--radius-md);\n}\n\n.dark .skeleton {\n  background-color: var(--color-slate-700);\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.card-skeleton {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.card-skeleton__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.card-skeleton__body {\n  margin-bottom: 1rem;\n}\n\n.table-skeleton {\n  overflow: hidden;\n}\n\n.table-skeleton__table {\n  width: 100%;\n}\n\n.table-skeleton__th {\n  padding: 0.75rem 1.5rem;\n}\n\n.table-skeleton__td {\n  padding: 1rem 1.5rem;\n}\n\n.chart-skeleton__title {\n  height: 2rem;\n  width: 12rem;\n  margin-bottom: 1.5rem;\n}\n\n.chart-skeleton__chart {\n  height: 16rem;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.chart-skeleton__legend {\n  display: flex;\n  gap: 1rem;\n}\n\n.chart-skeleton__legend-item {\n  height: 1rem;\n  flex: 1;\n}\n\n.grid-skeleton {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .grid-skeleton {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .grid-skeleton {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Search Bar */\n.search-bar {\n  position: relative;\n}\n\n.search-bar__icon-left {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  padding-left: 0.75rem;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.search-bar__icon-left svg {\n  height: 1.25rem;\n  width: 1.25rem;\n  color: var(--color-gray-400);\n}\n\n.search-bar__input {\n  padding-left: 2.5rem;\n}\n\n.search-bar__clear {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  padding-right: 0.75rem;\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  color: var(--color-gray-400);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.search-bar__clear:hover {\n  color: var(--color-gray-600);\n}\n\n.dark .search-bar__clear:hover {\n  color: var(--color-gray-300);\n}\n\n.search-bar__clear svg {\n  height: 1.25rem;\n  width: 1.25rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
